import { useState } from 'react';
import { Text, Button } from 'native-base';

// Assets
import { theme } from '@breakroom-nx/assets';

// Classes & Types
import { FeedbackType } from '../../';

import {
  ThumbUpIcon as TUOutline,
  ThumbDownIcon as TDOutline,
} from 'react-native-heroicons/outline';
import {
  ThumbUpIcon as TUSolid,
  ThumbDownIcon as TDSolid,
} from 'react-native-heroicons/solid';

interface VotingButtonProps {
  upvote: boolean;
  disabled: boolean;
  voteCount: number;
  voteState: FeedbackType;
  updateVotes: (upvote: boolean) => void;
}

export const VotingButton = ({
  upvote = true,
  disabled = false,
  voteCount = 0,
  voteState = FeedbackType.None,
  updateVotes,
}: VotingButtonProps) => {
  const scoldButton = () => {
    switch (voteState) {
      case FeedbackType.Scold:
        return <TDSolid color={theme.colors.red[200]} size={20} />;
      case FeedbackType.Praise:
        return <TDSolid color={theme.colors.surface[400]} size={20} />;
      case FeedbackType.None:
        return <TDOutline color={theme.colors.red[200]} size={20} />;
    }
  };

  const praiseButton = () => {
    switch (voteState) {
      case FeedbackType.Scold:
        return <TUSolid color={theme.colors.surface[400]} size={20} />;
      case FeedbackType.Praise:
        return <TUSolid color={theme.colors.primary[400]} size={20} />;
      case FeedbackType.None:
        return <TUOutline color={theme.colors.primary[400]} size={20} />;
    }
  };

  return (
    <Button
      rounded={'full'}
      disabled={disabled}
      rightIcon={upvote ? praiseButton() : scoldButton()}
      opacity={0.75}
      backgroundColor={'rgba(255, 255, 255, 0.07)'}
      _hover={{
        opacity: 1,
      }}
      _pressed={{
        backgroundColor: 'rgba(255, 255, 255, 0.07)',
        opacity: 0.7,
      }}
      onPress={() => {
        updateVotes(upvote);
      }}
    >
      <Text color={theme.colors.surface[600]}>{voteCount}</Text>
    </Button>
  );
};
